import { createSvgIcon } from "@mui/material";

export const AlignLRIcon = createSvgIcon(
  <svg viewBox="0 0 15 9" fill="none">
    <path
      fill="currentColor"
      d="M.633 8.438A.625.625 0 0 1 0 7.805V.633C0 .29.29 0 .633 0c.369 0 .633.29.633.633v7.172a.61.61 0 0 1-.633.633"
    />
    <path fill="currentColor" d="M1.266 3.586h12v1.266h-12z" />
    <path
      fill="currentColor"
      d="M13.898 8.438a.625.625 0 0 1-.632-.633V.633c0-.343.29-.633.632-.633.37 0 .633.29.633.633v7.172a.61.61 0 0 1-.633.633"
    />
  </svg>,
  "AlignLRIcon",
);
